import React from "react";

import { FormattedMessage, useIntl } from "react-intl";
import { useTheme } from "styled-components";

import Button from "ds/Button";
import Illustration from "Vendor_resources/images/empty-metrics.svg";
import IllustrationDark from "Vendor_resources/images/empty-metrics_dark.svg";

import * as S from "./Errors.styles";

const EmptyMetrics = () => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <S.Layout>
      <S.Illustration>
        <img
          src={theme.name === "dark" ? IllustrationDark : Illustration}
          alt={intl.formatMessage({ id: "metrics.error.empty.header" })}
        />
      </S.Illustration>
      <S.H3 tag="h3">
        <FormattedMessage id="metrics.error.empty.header" />
      </S.H3>
      <S.Paragraph>
        <FormattedMessage id="metrics.error.empty.paragraph" />
      </S.Paragraph>
      <Button
        variant="link"
        as="a"
        analyticId="learnmore"
        target="_blank"
        href={intl.formatMessage({
          id: "links.documentation.redeploy"
        })}
      >
        <FormattedMessage id="learnmore" />
      </Button>
    </S.Layout>
  );
};

export default EmptyMetrics;
